import { LayoutGrid, List } from 'lucide-react';

import { ToggleGroup, ToggleGroupItem } from '@/_shared/components/ui/toggle-group';
import type { ViewMode } from '@/_shared/lib/list-controls';
import { cn } from '@/_shared/lib/utils';

interface ViewToggleProps {
  value: ViewMode;
  onChange: (view: ViewMode) => void;
  className?: string;
}

/** Card/list segmented control for a list page. Guards against Radix single-toggle deselecting to empty. */
export function ViewToggle({ value, onChange, className }: ViewToggleProps): React.ReactElement {
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="md"
      value={value}
      onValueChange={(next) => {
        if (next === 'card' || next === 'list') onChange(next);
      }}
      className={cn('shrink-0', className)}
      aria-label="View mode"
    >
      <ToggleGroupItem value="card" aria-label="Card view">
        <LayoutGrid className="size-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="list" aria-label="List view">
        <List className="size-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
